import { MainAccountsReport } from './MainAccountsReport'

export const ReportsCnt = () => {
  return <MainAccountsReport />
}
